document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('#blog-posts');
	if (!section) return;
	if (section.dataset.blogPostsInitialized) return;
	section.dataset.blogPostsInitialized = 'true';

	const postsContainer = section.querySelector('.posts');
	const noResultsEl = section.querySelector('.no-results');
	const clearAllBtn = section.querySelector('.clear-filters');
	const categoryInputs = section.querySelectorAll('input[name="category"]');
	const sectorInputs = section.querySelectorAll('input[name="sector"]');
	const lhjToggle = section.querySelector('.lhj-toggle');
	const lhjChildInputs = section.querySelectorAll('input[name="sector"][data-lhj="true"]');
	const loadMoreBtn = section.querySelector('#load-more');
	const paginationContainer = section.querySelector('#pagination');

	const excludeIds = JSON.parse(section.dataset.excludeIds || '[]');

	let currentPage = 1;
	let currentCategories = [];
	let currentSectors = [];
	let isLoading = false;
	let debounceTimer = null;
	/** Ignore responses from older requests when filters change during an in-flight load */
	let latestLoadId = 0;

	const liveRegion = document.createElement('div');
	liveRegion.setAttribute('aria-live', 'polite');
	liveRegion.setAttribute('role', 'status');
	liveRegion.className = 'screen-reader-text';
	section.appendChild(liveRegion);

	function getCheckedValues(inputs) {
		return Array.from(inputs)
			.filter(i => i.checked)
			.map(i => i.value);
	}

	async function loadPosts(page = 1, categories = [], sectors = [], append = false) {
		const loadId = ++latestLoadId;
		isLoading = true;

		if (loadMoreBtn) {
			loadMoreBtn.textContent = 'Loading...';
			loadMoreBtn.disabled = true;
		}

		try {
			if (!append) {
				postsContainer.classList.add('fade-out');
				await new Promise(resolve => setTimeout(resolve, 300));
			}

			if (loadId !== latestLoadId) {
				return;
			}

			const formData = new FormData();
			formData.append('action', 'load_blog_posts');
			formData.append('page', page.toString());
			categories.forEach(id => formData.append('category[]', id));
			sectors.forEach(value => formData.append('sector[]', value));
			excludeIds.forEach(id => formData.append('exclude_ids[]', id.toString()));

			const response = await fetch('/wp-admin/admin-ajax.php', {
				method: 'POST',
				body: formData,
			});

			const data = await response.json();

			if (loadId !== latestLoadId) {
				return;
			}

			if (!append) {
				postsContainer.innerHTML = data.html;
				postsContainer.offsetHeight;
				postsContainer.classList.remove('fade-out');
			} else {
				postsContainer.insertAdjacentHTML('beforeend', data.html);
			}

			const newCount = postsContainer.querySelectorAll('.tease-post').length;
			liveRegion.textContent = append
				? `More posts loaded, ${newCount} posts now showing`
				: `${newCount} posts loaded`;

			const hasResults = data.total > 0;
			if (noResultsEl) {
				if (!append && !hasResults) {
					noResultsEl.hidden = false;
					postsContainer.hidden = true;
				} else {
					noResultsEl.hidden = true;
					postsContainer.hidden = false;
				}
			}

			if (paginationContainer) {
				paginationContainer.style.display = data.has_more ? 'block' : 'none';
			}

			currentPage = page;
			currentCategories = categories;
			currentSectors = sectors;
		} catch (error) {
			console.error('Error loading posts:', error);
			if (loadId === latestLoadId) {
				postsContainer.classList.remove('fade-out');
			}
		} finally {
			if (loadId === latestLoadId) {
				isLoading = false;
				if (loadMoreBtn) {
					loadMoreBtn.textContent = 'Load More';
					loadMoreBtn.disabled = false;
				}
			}
		}
	}

	function applyFiltersDebounced() {
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => {
			const categories = getCheckedValues(categoryInputs);
			const sectors = getCheckedValues(sectorInputs);
			loadPosts(1, categories, sectors, false);
		}, 150);
	}

	function syncLhjParentState() {
		if (!lhjToggle || lhjChildInputs.length === 0) return;
		const checkedCount = Array.from(lhjChildInputs).filter(i => i.checked).length;
		if (checkedCount === 0) {
			lhjToggle.checked = false;
			lhjToggle.indeterminate = false;
		} else if (checkedCount === lhjChildInputs.length) {
			lhjToggle.checked = true;
			lhjToggle.indeterminate = false;
		} else {
			lhjToggle.checked = false;
			lhjToggle.indeterminate = true;
		}
	}

	categoryInputs.forEach(input => {
		input.addEventListener('change', applyFiltersDebounced);
	});

	sectorInputs.forEach(input => {
		input.addEventListener('change', () => {
			if (input.dataset.lhj === 'true') {
				syncLhjParentState();
			}
			applyFiltersDebounced();
		});
	});

	if (lhjToggle) {
		lhjToggle.addEventListener('change', () => {
			lhjChildInputs.forEach(child => {
				child.checked = lhjToggle.checked;
			});
			lhjToggle.indeterminate = false;
			applyFiltersDebounced();
		});
	}

	if (clearAllBtn) {
		clearAllBtn.addEventListener('click', () => {
			categoryInputs.forEach(i => (i.checked = false));
			sectorInputs.forEach(i => (i.checked = false));
			if (lhjToggle) {
				lhjToggle.checked = false;
				lhjToggle.indeterminate = false;
			}
			loadPosts(1, [], [], false);
		});
	}

	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', () => {
			loadPosts(currentPage + 1, currentCategories, currentSectors, true);
		});
	}

	const disclosureTargets = section.querySelectorAll(
		'.filter-group-content[data-collapsed], .lhj-children[data-collapsed]',
	);
	disclosureTargets.forEach(target => {
		target.inert = target.dataset.collapsed === 'true';
	});

	const groupToggles = section.querySelectorAll('.filter-group-toggle, .lhj-expand');
	groupToggles.forEach(btn => {
		btn.addEventListener('click', () => {
			const expanded = btn.getAttribute('aria-expanded') === 'true';
			const next = !expanded;
			btn.setAttribute('aria-expanded', String(next));
			const targetId = btn.getAttribute('aria-controls');
			const target = targetId ? section.querySelector(`#${targetId}`) : null;
			if (!target) return;
			target.dataset.collapsed = String(!next);
			target.inert = !next;
		});
	});
});
